import {query, transition, trigger, useAnimation} from '@angular/animations';
import {Component, OnInit} from '@angular/core';
import {FormBuilder} from '@angular/forms';
import {ActivatedRoute, Router} from '@angular/router';
import {TranslateService} from '@ngx-translate/core';
import {ToastrService} from 'ngx-toastr';
import {fadeInAnimation, slideIn50StaggerAnimation, slideInAnimation} from '../../../shared/animation/common.animation';
import {ListContentComponent} from '../../../shared/components/list-content/list-content.component';
import {PurchaseOrderStatusEnum} from '../../../shared/enums/Purchase-order.status.enum';
import {ListContentModel} from '../../../shared/models/list-content.model';
import {PurchaseOrderModel} from '../../../shared/models/purchase-order/purchase-order.model';
import {PurchaseOrderService} from '../services/purchase-order-service';

@Component({
  selector: 'purchase-order-list',
  templateUrl: './purchase-order-list.component.html',
  styleUrls: ['./purchase-order-list.component.scss'],
  animations: [
    trigger('fadeIn', [
      transition(':enter', [
        useAnimation(fadeInAnimation)
      ])
    ]),
    trigger('slideIn', [
      transition(':enter', [
        useAnimation(slideInAnimation)
      ])
    ]),
    trigger('slideInStagger', [
      transition(':enter', [
        query('.slide-in-animation', [
          useAnimation(slideIn50StaggerAnimation)
        ], {optional: true})
      ])
    ])
  ]
})
export class PurchaseOrderListComponent extends ListContentComponent implements OnInit {

  listContent: PurchaseOrderModel[] = [];
  status = Object.keys(PurchaseOrderStatusEnum);
  statusForFilter = Object.keys(PurchaseOrderStatusEnum).filter(x => x != PurchaseOrderStatusEnum.EXPIRED);

  listParamValidator = {
    page: RegExp('^[1-9][0-9]*$'),
    size: ['6', '9', '12'],
    search: RegExp('.{3,}'),
    purchaseOrderNumber: 'string',
    sort: RegExp('^(purchaseOrderNumber|status|buyerName|requestNumber|createdDate)\,(asc|desc)$'),
    buyerName: 'string',
    requestNumber: 'string',
    status: RegExp(`^(${this.status.join('|')})(\,(${this.status.join('|')}))*$`),
  };

  constructor(public router: Router,
              public route: ActivatedRoute,
              private translateService: TranslateService,
              private toastrService: ToastrService,
              private fb: FormBuilder,
              private purchaseOrderService: PurchaseOrderService) {
    super(router, route);
    this.advancedSearchForm = this.fb.group({
      purchaseOrderNumber: [null],
      buyerName: [null],
      requestNumber: [null],
      status: [null]
    });
  }

  ngOnInit(): void {
    this.size = 6;
    this.sort = 'status';
    this.sortDirection = 'asc';

    super.ngOnInit();
    this.subscribeToQueryParam();
  }


  retrieveListContent(params): void {
    const page = params.page ? params.page - 1 : 0;
    const size = params.size ? params.size : 6;
    const search = params.search ? params.search : null;
    const sort = params.sort ? params.sort : 'status,asc';
    const advancedSearch = this.purchaseOrderService.mapAdvancedSearchForm(params);
    this.purchaseOrderService.getPurchaseOrdersByPage(page, size, sort, search, advancedSearch).subscribe({
      next: (res: ListContentModel) => {
        this.listContent = res.content;
        this.totalElements = res.totalElements;
        this.numberOfElements = res.numberOfElements;
        this.isListEmpty = !this.isSearchActive && res.empty;

        if (res.totalPages !== 0 && params.page > res.totalPages) {
          this.updateQueryParam({page: res.totalPages});
        }

        this.firstCallDone = true;
      },
      error: (error: any) => {
        this.toastrService.error(this.translateService.instant('global.ts.error'));
      },
    });
  }
}
